import { render } from "./SingleBundle.vue?vue&type=template&id=61785c86&scoped=true"
import script from "./SingleBundle.vue?vue&type=script&lang=js"
export * from "./SingleBundle.vue?vue&type=script&lang=js"

import "./SingleBundle.vue?vue&type=style&index=0&id=61785c86&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61785c86"]])

export default __exports__